import { IDepositServiceMock } from "@/services/backend/deposit/deposit.types";

export const mockDepositService = (): IDepositServiceMock => ({
  prmTransactions: jest.fn(),
});
